import React, { useState } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./contact.css";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import Img4 from "./fa6-brands_linkedin-in.png";
import Img5 from "./fa6-brands_instagram.png";
import Img6 from "./fa6-brands_x-twitter.png";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Map from "./Indiamap.png";
import ContactImage from "./contactImage.png";
const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    source: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(form);
  // };
  const [region, setRegion] = useState("CorporateOffice");

  // const data = {
  //   "North America": {
  //     phone: "(629) 565-0129",
  //     email: "info@example.com",
  //     location: "6391 Elgin St. Celina, Delaware 10299",
  //     schedule: [
  //       { day: "Monday", hours: "9 am - 8 pm" },
  //       { day: "Tuesday-Friday", hours: "12 pm - 9 pm" },
  //       { day: "Saturday", hours: "8 am - 3 pm" },
  //     ],
  //   },
  //   Europe: {
  //     phone: "(123) 456-7890",
  //     email: "europe@example.com",
  //     location: "123 Baker Street, London, UK",
  //     schedule: [
  //       { day: "Monday", hours: "10 am - 6 pm" },
  //       { day: "Tuesday-Friday", hours: "10 am - 7 pm" },
  //       { day: "Saturday", hours: "9 am - 2 pm" },
  //     ],
  //   },
  //   Asia: {
  //     phone: "(987) 654-3210",
  //     email: "asia@example.com",
  //     location: "456 Tokyo Tower, Japan",
  //     schedule: [
  //       { day: "Monday", hours: "8 am - 5 pm" },
  //       { day: "Tuesday-Friday", hours: "8 am - 6 pm" },
  //       { day: "Saturday", hours: "8 am - 1 pm" },
  //     ],
  //   },
  //   Australia: {
  //     phone: "(555) 123-4567",
  //     email: "australia@example.com",
  //     location: "789 Sydney Harbor, Australia",
  //     schedule: [
  //       { day: "Monday", hours: "9 am - 4 pm" },
  //       { day: "Tuesday-Friday", hours: "10 am - 5 pm" },
  //       { day: "Saturday", hours: "10 am - 3 pm" },
  //     ],
  //   },
  // };
  const data = {
    CorporateOffice: {
      phone: ["+91 8982160184", "9338499112"],
      email: "corporatebusiness@udayasolutions.com",
      location:
        "3010, Laxmi Priya Twin City Tower, Pahal, Bhubaneswar ,Odisha – 752101",
      schedule: [
        { day: "Monday", hours: "9 am - 8 pm" },
        { day: "Tuesday-Friday", hours: "12 pm - 9 pm" },
        { day: "Saturday", hours: "8 am - 3 pm" },
      ],
    },
    Bangalore: {
      phone: ["+91 9892610818", "9338499112"],
      email: "doctors.recruitment@udayasolutions.com",
      location:
        "C 204, Krishvi Dhavala, Kadubisanahalli Doddakanalli Main Road, Balladur, Bangalore, Karnataka – 560035",
      schedule: [
        { day: "Monday", hours: "9 am - 8 pm" },
        { day: "Tuesday-Friday", hours: "12 pm - 9 pm" },
        { day: "Saturday", hours: "8 am - 3 pm" },
      ],
    },
    Jamshedpur: {
      phone: ["+91 9892610818", "9338499112"],
      email: "doctors.recruitment@udayasolutions.com",
      location:
        "H No. 09, Anil Sur Path Cross Road-A, New River View Colony, Uliyan, Kadma, Jamshedpur ,Jharkhand – 831005",
      schedule: [
        { day: "Monday", hours: "9 am - 8 pm" },
        { day: "Tuesday-Friday", hours: "12 pm - 9 pm" },
        { day: "Saturday", hours: "8 am - 3 pm" },
      ],
    },
    Mumbai: {
      phone: ["+91 9892610818", "9338499112"],
      email: "corporatebusiness@udayasolutions.com",
      location:
        "HD – 066, Express Tower, Nariman Point, Marine Drive, Mumbai ,Maharashtra – 400021",
      schedule: [
        { day: "Monday", hours: "9 am - 8 pm" },
        { day: "Tuesday-Friday", hours: "12 pm - 9 pm" },
        { day: "Saturday", hours: "8 am - 3 pm" },
      ],
    },
    Ghaziabad: {
      phone: ["+91 9892610818", "9338499112"],
      email: "corporatebusiness@udayasolutions.com",
      location:
        "Qr. No. 178, Vartalok Apartment, Sector – 4, Ghaziabad ,UP - 201012",
      schedule: [
        { day: "Monday", hours: "9 am - 8 pm" },
        { day: "Tuesday-Friday", hours: "12 pm - 9 pm" },
        { day: "Saturday", hours: "8 am - 3 pm" },
      ],
    },
  };

  return (
    <>
      <Navb />
      {/* <Container className="Contact"> */}
      {/* <Row>
          <Col lg={6} md={8} sm={8} className="d-flex justify-content-center">
            <img src={Map} alt="Map" />
          </Col>
          <Col lg={6} md={8} sm={8}>
            <div className="ContactUsData ">
              <img src={Img3} alt="Img3" />
              <div className="ContactUsDatas">
                <div className="ContactUsDatasTop">Corporate Office</div>
                <div className="ContactUsDatasBottom">
                  <a href="#" className="black">
                    3010, Laxmi Priya Twin City Tower, Pahal, Bhubaneswar –
                    752101, Odisha
                  </a>
                </div>
              </div>
            </div>
            <div className="ContactUsData ">
              <img src={Img3} alt="Img3" />
              <div className="ContactUsDatas">
                <div className="ContactUsDatasTop">Branch Offices</div>
                <div className="ContactUsDatasBottom">
                  <a href="#" className="black">
Bangalore: C 204, Krishvi Dhavala, Kadubisanahalli Doddakanalli Main Road, Balladur, Bangalore – 560035, Karnataka
Jamshedpur: H No. 09, Anil Sur Path Cross Road-A, New River View Colony, Uliyan, Kadma, Jamshedpur – 831005, Jharkhand
Mumbai: HD – 066, Express Tower, Nariman Point, Marine Drive, Mumbai – 400021, Maharashtra
Ghaziabad: Qr No. 178, Vartalok Apartment, Sector – 4, Ghaziabad 201012, UP
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row> */}
      {/* <Row className="justify-content-center g-5">
          <Col
            lg={5}
            md={8}
            sm={8}
            className="Contactus align-items-center col-10"
          >
            <div className="ContactusTitle">Contact Us</div>
            <div className="ContactUsData">
              <img src={Img1} alt="Img1" />
              <div className="ContactUsDatas ">
                <div className="ContactUsDatasTop">Phone Number</div>
                <div className="ContactUsDatasBottom">
                  {" "}
                  <a href="#" className="black">
                    +91 7741256887
                  </a>
                </div>
              </div>
            </div>
            <div className="ContactUsData ">
              <img src={Img2} alt="Img2" />
              <div className="ContactUsDatas">
                <div className="ContactUsDatasTop">Email</div>
                <div className="ContactUsDatasBottom">
                  <a href="#" className="black">
                    consult@udayasolutions.com
                  </a>
                </div>
              </div>
            </div>
            <div className="ContactUsData ">
              <img src={Img3} alt="Img3" />
              <div className="ContactUsDatas">
                <div className="ContactUsDatasTop">Office</div>
                <div className="ContactUsDatasBottom">
                  <a href="#" className="black">
                    3010, 3rd Floor, Twin City Tower, NH-16 Pahala, Bhubaneswar,
                    Odisha 752101
                  </a>
                </div>
              </div>
            </div>
            <div className="follow">Follow Us</div>
            <div className="link">
              <a href="#">
                <img src={Img4} alt="Img4" />
              </a>
              <a href="#">
                <img src={Img5} alt="Img5" />
              </a>
              <a href="#">
                <img src={Img6} alt="Img6" />
              </a>
            </div>
          </Col>
          <Col lg={5} md={8} sm={8} className="getInTouch col-10">
            <div className="ContactusTitle">Get In Touch</div>
            <form
              className="getInTouchForm"
              action="https://formspree.io/f/xbljrkyq"
              method="POST"
            >
              <input
                type="text"
                name="name"
                className="getInTouchFormInput"
                placeholder="Name"
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="phone"
                className="getInTouchFormInput"
                placeholder="Phone No."
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="getInTouchFormInput"
                onChange={handleChange}
                required
              />
              <select
                name="source"
                className="getInTouchFormInput"
                onChange={handleChange}
                required
              >
                <option value="">How did you hear about us</option>
                <option value="option1">Option 1</option>
                <option value="option2">Option 2</option>
              </select>
              <textarea
                className="getInTouchFormInput"
                name="message"
                style={{ height: "145px" }}
                placeholder="Leave a message"
                onChange={handleChange}
              />
              <button className="getInTouchFormSubmit" type="submit">
                Submit
              </button>
            </form>
          </Col>
        </Row> */}
      {/* </Container> */}

      <div className="container my-5">
        <div className="row align-items-center">
          {/* Left Illustration Section */}
          <div className="col-md-6 text-center mb-4 mb-md-0">
            <div className="illustration-container">
              <img
                src={ContactImage}
                alt="ContactImage"
                style={{ width: "100%" }}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="d-flex gap-3 pb-2">
              <span
                style={{ "font-weight": "600", color: "var(--primary-color)" }}
              >
                Contact Information
              </span>
            </div>
            <div
              className="Heading43 mt-2 mt-lg-0 mb-4"
              style={{ "line-height": "55px", color: "var(--primary-color)" }}
            >
              Let Your Wanderlust <br /> Guide You
            </div>
            <form
              style={{
                "background-color": "#F1F5EB",
                padding: "2rem 3rem",
                "border-radius": "1rem",
              }}
            >
              <div className="d-flex gap-3">
                <div className="mb-3" style={{ width: "100%" }}>
                  <label htmlFor="email" className="form-label">
                    Your Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Your Email"
                  />
                </div>
                <div className="mb-3" style={{ width: "100%" }}>
                  <label htmlFor="phone" className="form-label">
                    Your Phone
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="phone"
                    placeholder="Your Phone"
                  />
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="address" className="form-label">
                  Your Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  placeholder="Your Address"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  rows="4"
                  placeholder="Write Message..."
                ></textarea>
              </div>
              <button type="submit" className="whitebutton">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="container py-5" style={{ width: "70%" }}>
        <div className="d-flex justify-content-center gap-3 pb-2">
          {/* <img src={Homeimg4} alt="Homeimg4" />{" "} */}
          <span style={{ "font-weight": "600", color: "var(--primary-color)" }}>
            Contact Information
          </span>
        </div>
        <div
          className="Heading43 text-center mt-2 mt-lg-0 mb-4"
          style={{ "line-height": "55px", color: "var(--primary-color)" }}
        >
          Let Your Wanderlust <br /> Guide You
        </div>
        {/* <h2 className="text-center mb-4">Let Your Wanderlust Guide You</h2> */}
        <div className="d-flex justify-content-center mb-4 flex-wrap gap-3">
          {Object.keys(data).map((key) => (
            <button
              key={key}
              className={`btn  ${
                region === key ? "btn-warning" : "btn-outline-warning"
              }`}
              onClick={() => setRegion(key)}
            >
              {key}
            </button>
          ))}
        </div>
        <div className=" p-4 shadow-lg">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex flex-column mb-3">
                <div>Requesting A Call:</div>
                {/* <div className="fw-bold">{data[region].phone}</div> */}
                <div className="d-flex flex-column mb-3">
                
                    <div>Phone:</div>
                    <div className="fw-bold"> {data[region].phone.join(" / ")}</div>
                  </div>
              
              </div>
              <div className="d-flex flex-column mb-3">
                <div>E-mail:</div>
                <div className="fw-bold">{data[region].email}</div>
              </div>
              <div className="d-flex flex-column mb-3">
                <div>Location:</div>
                <div className="fw-bold">{data[region].location}</div>
              </div>
            </div>
            {/* <div
              className="col-md-6"
              style={{ "border-left": "1px solid #d3d3d3" }}
            >
              {data[region].schedule.map((schedule, index) => (
                <div className="d-flex flex-column mb-3" key={index}>
                  <div>{schedule.day}:</div>
                  <div className="fw-bold">{schedule.hours}</div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>

      <div style={{ width: "100%", margin: "0 auto" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3741.2170617580814!2d85.88190331008973!3d20.332649681069576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190b8ac7db530b%3A0x4cd6312fda9a8475!2sUdaya%20Solution%20Private%20Limited!5e0!3m2!1sen!2sin!4v1728235461865!5m2!1sen!2sin"
          width="100%"
          height="500"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
